import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.GetEnvelope.IRequest;
type Response = Api.Core.Contract.GetEnvelope.IResponse;
type Headers = Api.Core.Contract.GetEnvelope.IHeaders;
const url = '/api/Sales/Contract/DocuSignEnvelope/:envelopeId';
export default async function contractGetEnvelopeApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
